export default {
    setAppId(app_id){
        localStorage.setItem('9manad_line_app_id',app_id)
    }
    ,getAppId(){
        return localStorage.getItem('9manad_line_app_id')
    }
    ,setAppConfig(config){
        localStorage.setItem('9manad_line_app_config_backgroud',config.backgroudImage)
        localStorage.setItem('9manad_line_app_config_logo',config.logo)
        localStorage.setItem('9manad_line_app_config_name',config.appName)
        localStorage.setItem('9manad_line_app_config_addfriend_url',config.addfriend_url)
    }
    ,getAppConfigBackgroud(){
        return localStorage.getItem('9manad_line_app_config_backgroud')
    }
    ,getAppConfigLogo(){
        return localStorage.getItem('9manad_line_app_config_logo')
    }
    ,getAppConfigName(){
        return localStorage.getItem('9manad_line_app_config_name')
    }
    ,getAppConfigAddFriendUrl(){
        return localStorage.getItem('9manad_line_app_config_addfriend_url')
    }
}